import { PublicApiClient } from '@public-api-contracts/client/PublicApiClient';

export const apiClient = new PublicApiClient(PUBLIC_API_BASE_URL, ACCOUNT_ID);
